export default {
  accepted_message: "Đặt cược của bạn đã được chấp nhận.",
  waiting_message: "Đặt cược của bạn đã được chờ đợi.",
  login: "Vui lòng đăng nhập để tiếp tục...",
  password_rule: "* Mật khẩu là chữ hoa và chữ thường và phải có độ dài từ 6 dến 10 ký tự.",
  nickname_rule:
    "* Bạn có thể đặt biệt danh để hiện thị và đăng nhập (6 đến 15 ký tự chữ và số). Vui lòng ghi chú lại rằng bạn có thể cài đặt biệt danh chỉ 1 lần duy nhất. Bạn không thể thay đổi hoặc huỷ bỏ biệt danh khi đã được cài đặt.",
  change_password_succeed: "Thay đổi mật khẩu thành công.",
  add_secondary_succeed: "Đặt biệt danh thành công.",
  succeed: "Thao tác thành công!",
  failed: "Thao tác thất bại!",
  no_information_available: "Thông tin không tồn tại.",
  select_display_language: "Chọn ngôn ngữ mặc định ưu thích của bạn.",
  select_odds_type: "Chọn hiển thị mặc định tỷ lệ cược loại ưa thích của bạn.",
  select_page_type: "Chọn loại trang ưa thích của bạn như mặc định để hiển thị trong cả ngày hôm nay và trang thị trường sớm.",
  select_show_score_map: "Kích hoạt tính năng hệ thống tự động hiển thị bản đồ điểm trong khi đặt cược.",
  select_default_event_sorting: "Chọn sự kiện mặc định ưu tiên sắp xếp hiển thị của bạn.",
  select_market_type: "Chọn thị trường ưa thích của bạn.",
  select_page_size: "Chọn kích thước trang ưa thích của bạn.",
  change_sports_menu_order: "Hãy kéo các môn thể thao để thay đổi thứ tự mong muốn của danh mục thể thao.",
  view_outstanding_bets_in_bet_list: "Các cược đang đợi có thể mất ít thời gian chấp nhận. Vui lòng vào mục Danh sách cược để xem các cược đang đợi mới nhất.",
  time_display_in_gmt_plus_8: "Thời gian trên được hiển thị với GMT+8.",
  select_default_stake: "Kích hoạt tính năng hệ thống tự động nhập tiền cược đã được điều chỉnh của bạn và lần cuối đặt cược .",
  bet_empty: "Phiêu cược của bạn trống. Vui lòng nhấp vào tỷ lệ cược trong bảng để lựa chọn đặt cược của bạn.",
  no_event: "Không có trận đấu hoặc trò chơi có sẵn bây giờ. Vui lòng truy cập các sự kiện thể thao hoặc trò chơi hoặc quay lại sau.",
  no_bets: "Không có mã cược đang chạy",
  no_waiting: "Không mã cược đang chờ",
  no_void: "Không có mã cược vô hiệu",
  odds_changed: "Tỷ lệ thay đổi,",
  confirmation: "Bạn có xác nhận tiến hành đặt mã cược này không ?",
  olderversion: "Phiên bản hiện tại là phiên bản cũ , nhấn OK để tiến hành cập nhật hoặc nhấn Ctrl + F5.",
  gmt8: "Thời gian trên được hiển thị với GMT+8.",
  no_betting_market: "Không có thị trường cá cược",
  note_1: "Các cược nổi bật có thể mất một thời gian để xử lý. Vui lòng truy cập Cược của tôi để xem các cược nổi bật mới nhất của bạn.",
  match_not_started: "Trận đấu chưa bắt đầu",

  banner1a: "PICK A THỂ THAO",
  banner1b: "NHẬN TRONG TRÒ CHƠI",
  banner1c:
    "Với sự lựa chọn toàn diện hơn 90 môn thể thao và hàng ngàn trận đấu trực tiếp để đặt cược, cơn sốt adrenalin không bao giờ kết thúc. Đừng bỏ lỡ cơ hội của bạn để giành chiến thắng với đề nghị của chúng tôi về tỷ lệ cược tốt nhất và các môn thể thao hàng đầu trên thị trường.",
  banner2a: "CUỘC ĐỜI",
  banner2b: "HÃY BẮT ĐẦU",
  banner2c:
    "Kiếm được nhiều tiền, tất cả trong khi tận hưởng trải nghiệm chơi sòng bạc phong phú và đắm chìm tại bất kỳ phòng hạng sang nào của chúng tôi. Ngồi xuống, chơi trò chơi sòng bài yêu thích của bạn và nhận được sự tương tác chất lượng từ các đại lý trực tiếp, tất cả từ sự thoải mái của mọi lúc mọi nơi.",
  banner3a: "CHƠI TRÒ CHƠI CUỐI CÙNG",
  banner3b: "MỘT KINH NGHIỆM CÁCH MẠNG",
  banner3c: "Một lựa chọn rộng rãi của các trò chơi, xa như mắt có thể nhìn thấy. Nhận một hương vị đầu tiên của nó bây giờ.",
  banner4a: "OLYMPIC GAMES",
  banner4b: "TOKYO 2020",
  banner4c: "The 2020 Summer Olympics, officially the Games of the XXXII Olympiad and also known as Tokyo 2020, is an upcoming international multi-sport event scheduled to be held from 23 July to 8 August 2021 in Tokyo",
  banner4d: "We Bringing Back The EURO CUP 2020 For You!",
  banner5a: "LIVE SPORTS & GAME HIGHLIGHTS",
  banner5aa: "REACH YOUR COMMUNITY IN REAL TIME",
  banner5b: "Watch the best free Live TV and Highlights on the web and mobile devices",
  banner5c: "Get the latest sports scores anytime, anywhere",

  banner6a: "E-Fighting",
  banner6b: "Play the best fighting games",
  banner6c: "Collect your favorite characters, throw down in competitive combat, enter the battlefield and feel the fight! The more you play, the more you win!",

  banner7a: "NEW ESPORTS INTERFACE",
  banner7b: "ALL NEW EXPERIENCE",
  banner7c: "Extensive Choices of Esports markets, Industry Leading Betting Experience.",
  banner7d: "Popular massive multiplayer, Unbeatable odds & speedy settlement.",

  banner8a: "V-GAMES",
  banner8b: "PLAY THE GAMES, AND EXPERIENCE A DIFFERENT KIND OF VICTORY.",
  banner8c: "Experience a whole new level of victory.",
  banner8d: "Immerse yourself in a variety of games, from competitive to fighting, and explore new genres that wil keep you engaged for hours.",

  bannersb:
    "Tận hưởng cảm giác hồi hộp và phấn khích không ngừng nghỉ với vô số các cuộc thi thể thao để tham gia, cả ở địa phương và từ khắp nơi trên thế giới. Với chúng tôi, bạn sẽ luôn có tỷ lệ cược tốt nhất.",
  bannersl:
    "Hãy nghỉ ngơi từ thực tế, bước qua và tự mình trải nghiệm những điều tưởng tượng đã được đưa vào cuộc sống trong các trò chơi ảo chi tiết sống động của chúng tôi. Bạn chắc chắn sẽ bị nghiện. ",
  bannerlc:
    "Bước vào bên trong bất kỳ bộ sòng bạc độc quyền nào của chúng tôi, đắm mình vào các mục yêu thích sòng bạc cổ điển của bạn và đắm mình vào trải nghiệm tương tác với các đại lý trực tiếp tuyệt đẹp.",

  banner10a: "Wishing you a great fun time",
  banner10b: "While you row to the rhythm of roaring drums!",

  banner11a: "GIẢI ĐẤU BÓNG ĐÁ LỚN NHẤT HÀNH TINH",
  banner11b: "Cúp Bóng Đá Thế Giới 2022 sẽ được tổ chức tại Qatar từ 20 tháng 11 đến 18 tháng 12 năm 2022",
  banner11c: "32 đội thi đấu đã vượt qua vòng loại với Qatar là nước chủ nhà. Lần đầu tiên một sự kiện bóng đá lớn nhất thế giới được tổ chức tại đất nước vùng Trung Đông.",

  join_us1: "LÀM THẾ GIỚI NÀY",
  join_us2:
    "Với hành động 24/7 và một loạt các sản phẩm tuyệt vời để đặt cược, chúng tôi phục vụ cho hầu hết mọi loại sở thích. Thêm vào đó, chúng tôi đã nhận được những phần thưởng hấp dẫn, các chương trình khuyến mãi đang diễn ra và các khoản thanh toán hiệu quả để đảm bảo bạn tận hưởng trải nghiệm chơi game tốt nhất. Thực hiện bước đầu tiên và đăng ký với chúng tôi ngay bây giờ. Nó rất nhanh, dễ dàng và miễn phí.",
  join_us3: "THAM GIA CÙNG CHÚNG TÔI NGAY",

  icon1a: "Tối ưu hóa cho điện thoại di động",
  icon1b: "Trò chơi của chúng tôi có thể truy cập trên các nền tảng di động phổ biến, vì vậy bạn có thể chơi trò chơi trên thiết bị yêu thích của mình",
  icon2a: "BẢO MẬT & HPORT TRỢ NÂNG CAO",
  icon2b: "Thưởng thức các trò chơi của chúng tôi và giao dịch với chúng tôi với sự an tâm thực sự - trang web của chúng tôi hoàn toàn an toàn để bảo vệ quyền riêng tư và thông tin cá nhân của bạn",
  icon3a: "KINH NGHIỆM NGAY LẬP TỨC",
  icon3b: "Hấp dẫn, trực quan và tương tác - chúng tôi đã tuyển chọn và lựa chọn các sản phẩm cao cấp sẽ mang lại sự phấn khích mà bạn tìm kiếm",
  icon4a: "HỖ TRỢ KHÁCH HÀNG",
  icon4b: "Sự hài lòng của bạn là ưu tiên của chúng tôi. Chúng tôi sẽ nghe từ bạn nếu bạn có bất kỳ phản hồi hoặc truy vấn nào sẽ giúp chúng tôi phục vụ bạn tốt hơn",
  footer1a: "Đánh bạc dưới tuổi vị thành niên",
  footer1b:
    "Đánh bạc là bất hợp pháp đối với trẻ em dưới 18 tuổi. Mọi tiểu bang đều cấm đánh bạc bởi trẻ vị thành niên.{fvalue} sẽ tiến hành xác minh tuổi một cách ngẫu nhiên và tiền thắng sẽ bị hủy nếu con bạc dưới 18 tuổi. © 2004-2019. {fvalue} là một nhãn hiệu đã đăng ký quốc tế (Nhà cái cá cược thể thao được cấp phép). Đã đăng ký Bản quyền.",

  contactus_title1: "Các chuyên gia dịch vụ khách hàng sẵn sàng trả lời tất cả các câu hỏi của bạn, bao gồm các vấn đề thanh toán bằng tiếng Anh và tiếng Trung Quốc.",
  contactus_title2: "Cước cuộc gọi quốc tế có thể áp dụng cho bạn. Các cuộc gọi điện thoại cho chúng tôi có thể được ghi lại để bảo vệ khách hàng, xác minh thông tin, đảm bảo chất lượng và tuân thủ quy định.",
  days: "Ngày",
  hours: "Giờ",
  mins: "Phút",
  secs: "Giây",
  ldiff_changed: "Percent has changed",
  no_room: "Không còn phòng. Vui lòng chọn tùy chọn khác và tìm kiếm lại hoặc quay lại sau.",
  people_in_this_room: "Những người trong phòng này",
  room_full: "Phòng này đã đầy",
  room_joined: "Bạn đã vào phòng này",
  my_room: "Phòng tôi",
  pin_code: "vd: 123456",
  no_matches: "Hiện không có trận đấu hoặc trò chơi nào.",
  are_you_sure: "Bạn có chắc chắn thực hiện thao tác này không?",
  accept_terms: "Bằng cách đánh dấu, bạn xác nhận rằng bạn đã đọc, hiểu và đồng ý với các điều khoản và điều kiện ở trên.",
  accept_required: "Vui lòng đọc, hiểu và đồng ý với<br />các điều khoản và điều kiện ở trên trước khi tiếp tục.",
  must_accept_better_odds: "Theo mặc định, đặt cược sẽ tự động chấp nhận tỷ lệ cược tốt hơn. Vui lòng tham khảo Điều khoản & Điều kiện để biết thêm thông tin.",
  maintenance_notice: "Hiện tại, chúng tôi đang tiến hành bảo trì hệ thống. Vui lòng thử lại sau.",
  not_wining_prize_in_this_tournament: "Không giành được giải thưởng trong giải đấu này",
  you_did_not_join_this_room: "Bạn chưa tham gia phòng này",
  deduct_confirm: "Điều này sẽ bắt đầu trò chơi và tín dụng của bạn sẽ bị trừ.<br /> Bạn có chắc chắn muốn tiếp tục không?",
  over_max_match: "Các trận đấu trong giải đấu này vượt quá số lượng tối đa các trận đấu có thể chọn.<br />Vui lòng mở rộng giải đấu và chọn trận đấu mong muốn.",

  //tournament
  button_skip: "Bỏ qua chuyến tham quan",
  button_previous: "Trước đó",
  button_next: "Tiếp theo",
  button_stop: "Kết thúc",
  button_continue: "Tiếp tục",
  tour_content_1: "<h6>Chào mừng đến với giải đấu WBET</h6><p>Chúng tôi vui mừng thông báo về một giải đấu mới thú vị dành riêng cho những người ủng hộ trang web của chúng tôi.</p>",
  tour_content_2: "<h6>Phòng công cộng</h6><p>Các thành viên tham gia vào trò chơi cạnh tranh với nhau, thường phải trả phí vào cửa.</p>",
  tour_content_3: "<h6>Phòng riêng</h6><p>Thành viên có thể mở phòng để chơi với bạn bè bằng cách sử dụng mã pin được mời để vào.</p>",
  tour_content_4: "<h6>Phòng công cộng miễn phí</h6><p>Được tổ chức bởi các tổ chức khác nhau trong các sự kiện đặc biệt dành riêng cho thành viên, cho phép tham gia miễn phí.</p>",
  tour_content_5: "<h6>Tổng số người chơi có thể tham gia & tính phí</h6><p>Người chơi : Sức chứa của phòng.</p><p>Phí vào cửa: Căn cứ theo ưu đãi của Phòng ( Đơn vị tiền tệ của Chủ tài khoản).</ p>",
  tour_content_6: "<h6>Chi tiết phòng</h6><p>Nhấp vào đây để xem trước thống kê phòng và tham gia phòng.</p>",
  tour_content_7: "<h6>Chi tiết nhóm</h6><p>Tổng giải thưởng nhóm dành cho người chiến thắng & ID phòng duy nhất để tìm kiếm.</p>",
  tour_content_8: "<h6>Chi tiết bắt đầu phòng</h6><p>Trạng thái phòng & Hiển thị thời gian tham gia lần cuối.</p>",
  tour_content_9: "<h6>Tạo phòng riêng</h6><p>Để tạo phòng chơi riêng và mời bạn bè tham gia bằng mã pin để vào.</p>",
  tour_content_10: "<h6>Xếp hạng điểm</h6><p>Tính năng này hiển thị điểm cho người chơi xem và theo dõi kết quả.</p>",

  time_machine_information_HDP: "WBET Time Machine [HDP] dự đoán đội nào sẽ ghi nhiều bàn thắng nhất trong khoảng thời gian đã chọn.",
  time_machine_information_OU: "WBET Time Machine [OU] dự đoán tổng số bàn thắng trong khoảng thời gian đã chọn."
};
